import classNames from "classnames";
import { AnchorProps } from "types";
import "./buttons.scss";
import { ChevronRightIcon } from "assets";

interface Props extends AnchorProps {
  color?: string;
}

export const ExternalLink = ({ children, className, ...props }: Props) => (
  <a className={classNames("external-link", className)} {...props}>
    {children}
    <ChevronRightIcon className="chevron" />
  </a>
);
